import Header from "../../../components/header/Header";
import WebDevHero from "../../../components/Technologies/AI/AIHero/AIHero";
import WebDevTech from "../../../components/Technologies/AI/AITech/AITech";
import WebDevExpertise from "../../../components/Technologies/AI/AIExperties/AIExpertise";
import WebDevOutcomes from "../../../components/Technologies/AI/AIOutcomes/AIOutcomes";
import WebDevImpactCTA from "../../../components/Technologies/AI/AIImpactCTA/AIImpactCTA";
import Footer from "../../../components/Footer/Footer";
const AI = () => {
  return (
    <>
      <Header />
      <WebDevHero />
      <WebDevTech />
      <WebDevExpertise />
      <WebDevOutcomes />
      <WebDevImpactCTA />
      <Footer />
    </>
  );
};

export default AI;
